module.exports = __webpack_public_path__ + "img/00-menu-bar-off_05.7728f1cb.png";